import React from 'react';
import { PropTypes } from 'prop-types';
// styles
import styled from 'styled-components';
import SoFormHandlings from './SoFormHandlings';
import SoFormContainer from '../../components/layout/SoFormContainer';
import SoFormInsurance from './SoFormInsurance';
import SoFormComplementInfo from './SoFormComplementInfo';

const SoFormStepComplementsBody = ({ className }) => (
  <div className={className}>
    <SoFormContainer>
      <SoFormHandlings />
      <SoFormComplementInfo />
      <SoFormInsurance />
    </SoFormContainer>
  </div>
);

SoFormStepComplementsBody.propTypes = {
  className: PropTypes.string,
};

export default styled(SoFormStepComplementsBody)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 32px 0px;
  width: 100%;
  ${SoFormContainer} {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    padding: 0px;
    gap: 16px;
    padding: 0;
  }
  flex-grow: 1;
`;
